{
  "en": {
    "phase": {
      "attributes": {
        "end_date": "End Date",
        "internal_note": "Phase internal note",
        "name": "Name",
        "start_date": "Start Date"
      },
      "labels": {
        "phase": "No phase | One phase | {count} Phases"
      },
      "toasts": {
        "create": "Phase created",
        "delete": "Phase deleted",
        "update": "Phase updated"
      },
      "validation": {
        "needName": "Title is required",
        "needNumber": "Must be a number (e.g. 85)"
      }
    }
  }
}